import api from "../../../api";

export default {
  async getPols({ commit }, query) {
    commit("REQUEST_POLS");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_POLS",
        await api.getPols(query)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_POLS");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async deletePol({ commit }, id) {
    commit("REQUEST_DELETE_POL");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_DELETE_POL",
        await api.deletePol(id)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_DELETE_POL");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async updatePol({ commit }, item ) {
    console.log("UPDATE ", item)
    commit("REQUEST_UPDATE_POL");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_UPDATE_POL",
        await api.updatePol(item)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_UPDATE_POL");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async createPol({ commit }, item ) {
    commit("REQUEST_CREATE_POL");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_CREATE_POL",
        await api.createPol( item )
      );
    } catch (err) {
      commit("FAILURE_REQUEST_CREATE_POL");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
